import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaUserCircle } from "react-icons/fa";
import { updateProfile, getProfile } from "../Service/UserService";
import { Bounce, toast } from "react-toastify";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  gender: Yup.string().required("Gender is required"),
  dateTime: Yup.date().required("Date and Time are required"),
  latitude: Yup.number()
    .typeError("Must be a number")
    .required("Latitude is required"),
  longitude: Yup.number()
    .typeError("Must be a number")
    .required("Longitude is required"),
  location: Yup.string().required("Location is required"),
});

const EditDetail_Res = () => {
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dateTime: new Date(),
    latitude: "",
    longitude: "",
    location: "",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const token = Cookies.get("access_token");

  useEffect(() => {
    const signup_profile = Cookies.get("signup_profile");
    const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;
    console.log(user);
    console.log(signup_profile);

    if (signup_profile && user) {
      // Prefill First Name from Cookie if coming from Signup
      setInitialValues((prev) => ({ ...prev, firstName: user.name || "" }));
    } else {
      // Fetch user profile when coming from header
      fetchProfileData();
    }
  }, []);

  const fetchProfileData = async () => {
    try {
      const response = await axios.get("http://192.168.29.195:3000/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const data = response.data.data;
        const [year, month, day] = data.date_of_birth.split("-");
        const [hours, minutes] = data.birth_time.split(":");

        setInitialValues({
          firstName: data.name.split(" ")[0] || "",
          lastName: data.name.split(" ")[1] || "",
          gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1),
          dateTime: new Date(year, month - 1, day, hours, minutes),
          latitude: data.latitude,
          longitude: data.longitude,
          location: data.location_name,
        });
      }
    } catch (error) {
      toast.error("Failed to load profile", {
        position: "top-right",
        theme: "dark",
        transition: Bounce,
      });
    }
  };

  const handleUpdateProfile = async (values) => {
    try {
      if (!token) throw new Error("No token found, please log in again.");

      const dateObj = new Date(values.dateTime);
      const date_of_birth = `${String(dateObj.getDate()).padStart(
        2,
        "0"
      )}/${String(dateObj.getMonth() + 1).padStart(
        2,
        "0"
      )}/${dateObj.getFullYear()}`;
      const birth_time = `${String(dateObj.getHours()).padStart(
        2,
        "0"
      )}:${String(dateObj.getMinutes()).padStart(2, "0")}`;

      const payload = {
        name: `${values.firstName} ${values.lastName}`,
        gender: values.gender.toLowerCase(),
        date_of_birth,
        birth_time,
        latitude: parseFloat(values.latitude),
        longitude: parseFloat(values.longitude),
        location_name: values.location,
      };

      const res = await updateProfile(payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);

      toast.success("Profile updated successfully!", {
        position: "top-right",
        autoClose: 1200,
        theme: "dark",
        transition: Bounce,
      });

      Cookies.remove("signup_profile");

      setTimeout(() => navigate("/"), 100);
    } catch (error) {
      toast.error("Failed to update profile", {
        position: "top-right",
        theme: "dark",
        transition: Bounce,
      });
    }
  };

  return (
    <div className="w-screen h-screen bg-black flex items-center justify-center relative">
      <div className="absolute h-[300px] w-[300px] bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-3xl top-10 left-20 animate-pulse"></div>
      <div className="absolute h-[250px] w-[250px] bg-gradient-to-r from-pink-500 to-red-500 rounded-full blur-3xl bottom-10 right-20 animate-pulse"></div>

      <div className="mt-14 relative bg-gray-900 text-white p-6 rounded-xl shadow-xl w-[600px] border border-gray-700 backdrop-blur-md">
        <h2 className="text-2xl font-semibold text-center mb-3">
          Edit Profile
        </h2>
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center text-4xl">
            <FaUserCircle />
          </div>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleUpdateProfile}
          enableReinitialize
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
              <div>
                <label>First Name</label>
                <Field
                  name="firstName"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                />
                <ErrorMessage
                  name="firstName"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
              <div>
                <label>Last Name</label>
                <Field
                  name="lastName"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                />
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
              <div className="flex items-center">
                <label>Date & Time of Birth :</label>
              </div>
              <div className="w-full">
                <DatePicker
                  selected={values.dateTime}
                  onChange={(date) => setFieldValue("dateTime", date)}
                  showTimeSelect
                  showYearDropdown
                  scrollableYearDropdown // Enables scrolling in the year dropdown
                  yearDropdownItemNumber={50} // Number of years visible at once
                  dateFormat="Pp"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600 text-white"
                  wrapperClassName="w-full" // Ensure the wrapper also takes full width
                  maxDate={new Date()}
                  disabledKeyboardNavigation
                  onKeyDown={(e) => e.preventDefault()}
                  showMonthDropdown
                />
              </div>

              <div>
                <label>Gender</label>
                <Field
                  as="select"
                  name="gender"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Field>
                <ErrorMessage
                  name="gender"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
              <div>
                <label>Location</label>
                <Field
                  name="location"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                />
                <ErrorMessage
                  name="location"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
              <div>
                <label>Latitude</label>
                <Field
                  name="latitude"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                />
                <ErrorMessage
                  name="latitude"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
              <div>
                <label>Longitude</label>
                <Field
                  name="longitude"
                  className="w-full p-2 bg-gray-800 rounded border border-gray-600"
                />
                <ErrorMessage
                  name="longitude"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div className="col-span-2 flex justify-between mt-4">
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  Save Changes
                </button>
                <button
                  type="reset"
                  className="bg-red-600 px-4 py-2 rounded-lg hover:bg-red-700"
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditDetail_Res;
